import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IConfirmationRequest } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useSendConfirmation(briefId: string) {
  const {
    mutate: sendConfirmation,
    isLoading: isSending,
    isSuccess: isSent,
  } = useMutation({
    mutationFn: (data: IConfirmationRequest) =>
      BriefService.sendConfirmation(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    sendConfirmation,
    isSending,
    isSent,
  };
}
